import * as React from 'react';
import * as s from './ArrowLink.scss';

export interface ArrowLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  theme?: 'light' | 'normal' | 'button';
}

const Arrow = () => {
  return (
    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 10.9 19">
      <path d="M1.4 19L0 17.6l8.1-8.1L0 1.4 1.4 0l9.5 9.5"></path>
    </svg>
  );
};

const ArrowLink: React.SFC<ArrowLinkProps> = ({children, className, theme, ...otherProps}) => {
  const classes = [s.linkMore];
  if (theme) {
    classes.push(s[`linkMore${theme.charAt(0).toUpperCase() + theme.slice(1)}`]);
  }
  if (className) {
    classes.push(className);
  }
  return (<a className={classes.join(' ')} {...otherProps}>
    {children}
    {theme !== 'button' && <Arrow/>}
  </a>);
};

export default ArrowLink;
